import { extends as _extends, objectSpread2 as _objectSpread2, objectWithoutProperties as _objectWithoutProperties } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import React__default, { forwardRef, useMemo } from 'react';
import { useComponentTheme } from '../../theme/theme.context.esm.js';
import Slot from '../layout/slot/slot.esm.js';

var _excluded = ["anchorClassName", "alt", "caption", "children", "wrapperClassName", "className", "fit", "radius", "src", "width", "height", "imageRef", "loading", "mode", "testId", "onClick"];

// import { usePropId } from '../../utils/use-prop-id'

var PrivateImage = /*#__PURE__*/forwardRef(function Image(props, ref) {
  var theme = useComponentTheme('Image');
  var _props = _objectSpread2({}, props),
    _props$anchorClassNam = _props.anchorClassName,
    anchorClassName = _props$anchorClassNam === void 0 ? 'csg-tw-image' : _props$anchorClassNam,
    _props$alt = _props.alt,
    alt = _props$alt === void 0 ? '' : _props$alt,
    caption = _props.caption;
    _props.children;
    var _props$wrapperClassNa = _props.wrapperClassName,
    wrapperClassName = _props$wrapperClassNa === void 0 ? '' : _props$wrapperClassNa,
    _props$className = _props.className,
    className = _props$className === void 0 ? '' : _props$className,
    _props$fit = _props.fit,
    fit = _props$fit === void 0 ? 'contain' : _props$fit,
    _props$radius = _props.radius,
    radius = _props$radius === void 0 ? 'none' : _props$radius,
    src = _props.src,
    width = _props.width,
    _props$height = _props.height,
    height = _props$height === void 0 ? 'auto' : _props$height,
    imageRef = _props.imageRef,
    _props$loading = _props.loading,
    loading = _props$loading === void 0 ? 'lazy' : _props$loading,
    _props$mode = _props.mode,
    mode = _props$mode === void 0 ? 'dark' : _props$mode,
    testId = _props.testId,
    onClick = _props.onClick,
    rest = _objectWithoutProperties(_props, _excluded);
  // const id = usePropId(props.id)
  var classes = useMemo(function () {
    return theme.base({
      className: className,
      fit: fit,
      radius: radius
    });
  }, [theme, className, fit, radius]);
  var wrapperClasses = useMemo(function () {
    return theme.wrapper({
      className: wrapperClassName
    });
  }, [theme, wrapperClassName]);
  var imageCaptionClasses = useMemo(function () {
    return theme.caption({
      mode: mode
    });
  }, [theme, mode]);
  return caption ? /*#__PURE__*/React__default.createElement("figure", _extends({
    // id={id}
    ref: ref,
    className: "csg-tw-image-wrapper ".concat(wrapperClasses),
    onClick: onClick
  }, rest), /*#__PURE__*/React__default.createElement("img", {
    className: "".concat(anchorClassName, " ").concat(classes),
    src: src,
    alt: alt,
    height: height,
    width: width,
    loading: loading,
    ref: imageRef,
    "data-testid": testId
  }), caption ? /*#__PURE__*/React__default.createElement("figcaption", {
    className: "csg-tw-image-caption ".concat(imageCaptionClasses)
  }, caption) : null) : /*#__PURE__*/React__default.createElement(Slot, {
    className: "csg-tw-image-wrapper ".concat(wrapperClasses),
    onClick: onClick
  }, /*#__PURE__*/React__default.createElement("img", {
    className: "".concat(anchorClassName, " ").concat(classes),
    src: src,
    alt: alt,
    height: height,
    width: width,
    loading: loading,
    ref: imageRef,
    "data-testid": testId
  }));
});
var Image = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default.createElement(PrivateImage, _extends({
    ref: ref
  }, props));
});
Image.displayName = 'Image';
var Image$1 = Image;

export { PrivateImage, Image$1 as default };
//# sourceMappingURL=image.esm.js.map
